import React from 'react';
import classNames from 'classnames';
import I18n from 'i18n-js';

import CloseThin from '~/assets/images/icons/close-thin.svg';

import { ESuffix } from '../ESuffix';

import styles from './Body.module.scss';

export interface ICardsShredPopupBody {
  cards: {
    _id: string;
    cardTemplate: {
      name: string;
    };
    reward: boolean;
  }[];
  changeCardState?: (id: string) => void;
  suffix: ESuffix;
}

const Body: React.FC<ICardsShredPopupBody> = ({
  cards,
  changeCardState,
  suffix = ESuffix.singular,
}) => {
  const plural = suffix === ESuffix.plural;
  return (
    <div className={styles.body}>
      <span className={classNames(styles.title, !plural && styles.singleTitle)}>
        {I18n.t(`CardDetailView_confirm_shred_headline${suffix}`)}
      </span>
      {cards.map((card) => (
        <section
          key={card._id}
          className={classNames(
            styles.cardLabel,
            !plural && styles.singleCardLabel,
          )}
        >
          <span
            className={classNames(
              styles.cardName,
              !plural && styles.singleCardName,
            )}
          >
            {card.cardTemplate.name}
          </span>
          {changeCardState && plural && (
            <img
              src={CloseThin}
              alt="close-icon"
              className={styles.icon}
              onClick={() => changeCardState(card._id)}
            />
          )}
        </section>
      ))}
    </div>
  );
};

export default Body;
